import React from "react";
import "./styles.css";
import Component from "./components";
export default function App() {
  return (
    <div className="App">
      <Component />
    </div>
  );
}
